module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/nagoya_concept_01-e178b26a8e30c820224ac8ab50c2a4b4.jpg";